//Built-in libraries

//Third party libraries
import { UserGroupIcon } from '@heroicons/react/24/outline';
import { PlusIcon } from '@heroicons/react/24/solid';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import Button from '@/components/UI/Button';
import Card from '@/components/UI/Card/index.tsx';
//Custom components
//Services
import { useUsers } from '@/hooks/ReactQueryHooks/useUsersQuery';
import type { User } from '@/types/User';
import { isObjectEmpty } from '@/utils';
import { AddRoverTeamMemberForm } from './AddRoverTeamMemberForm';
import RoverTeamMember from './RoverTeamMember';

//Assets and Miscellaneous

interface IApplicationTeamCardProps {
  team: string;
  teams: { members: any[]; applicationLead: any };
}

function RoverTeamCard({ team, teams }: IApplicationTeamCardProps) {
  const { applicationId } = useParams();
  const [showAddModal, setShowAddModal] = useState<boolean>(false);
  const [modalMemberType, setModalMemberType] = useState<'LEAD' | 'MEMBER'>('MEMBER');

  useEffect(() => {
    if (isObjectEmpty(teams?.applicationLead)) {
      setModalMemberType('LEAD');
    }
  }, [teams?.applicationLead]);

  const toggleAddModal = () => {
    setShowAddModal((prev) => !prev);
  };
  const fetchUsers = useUsers({ params: { active: 'true' } });
  let users = fetchUsers?.data?.data;

  if (teams.members.length > 0) {
    teams.members.forEach((mem) => {
      users = users?.filter((u: User) => u.id !== mem?.user?.id);
    });
  }
  return (
    <>
      <Card
        title={team}
        titleElement={
          !isObjectEmpty(teams.applicationLead) ? (
            <span
              role='button'
              id={'add-team'}
              tabIndex={0}
              onClick={() => {
                toggleAddModal();
                setModalMemberType('MEMBER');
              }}
            >
              <PlusIcon />
            </span>
          ) : undefined
        }
      >
        {!isObjectEmpty(teams?.applicationLead) && (
          <div className='bg-neutralColor-lightest p-4 flex justify-between mt-2'>
            <p className='font-semibold'>Member</p>
            <p className='font-semibold'>Actions</p>
          </div>
        )}
        <section className='relative h-80' id='team'>
          <div className={'flex flex-col px-2 h-full overflow-y-scroll divide-y'}>
            {isObjectEmpty(teams?.applicationLead) ? (
              <div className='flex flex-col gap-2 justify-center items-center h-full'>
                <UserGroupIcon className='h-8 w-8 text-neutralColor-light' />
                <p className='text-center'>Application lead hasn't been selected yet.</p>
                <Button label='Assign Lead' btnStyle='btn-primary' btnType='button' btnSize='md' onClick={toggleAddModal} />
              </div>
            ) : (
              <RoverTeamMember
                key={teams.applicationLead.id}
                userId={teams.applicationLead.id}
                user={teams.applicationLead.name}
                profilePic={teams.applicationLead.profileImageUrl}
                isTempLead={false}
                isApplicationLead={true}
                handleChangeApplicationLead={() => {
                  setModalMemberType('LEAD');
                  setShowAddModal(true);
                }}
              />
            )}
            {teams?.members?.map((mem: any, _i: any) => (
              <RoverTeamMember
                key={mem.id}
                userId={mem.user.id}
                user={mem.user.name}
                profilePic={mem.user.profileImageUrl}
                isTempLead={mem.isTemporaryLead}
                isApplicationLead={false}
              />
            ))}
          </div>
        </section>
      </Card>
      {showAddModal && (
        <AddRoverTeamMemberForm
          title={modalMemberType === 'LEAD' ? 'Assign Application Lead' : 'Add Team Member'}
          hookFormConfig={{
            defaultValues: {
              applicationId,
            },
          }}
          modalHandler={toggleAddModal}
          users={users}
          memberType={modalMemberType}
        />
      )}
    </>
  );
}
export default RoverTeamCard;
